import React from 'react'
import Lottie from 'react-lottie'
import * as animationData from './loadingAnim.json'

const LoadingAnim = ({ width, height }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  return (
    <div>
      <Lottie
        options={defaultOptions}
        height={height ?? 25}
        width={width ?? 270}
      />
    </div>
  )
}

export default LoadingAnim
